export const accessoryKeys = {
  all: ['accessories'] as const,
  lists: () => [...accessoryKeys.all, 'list'] as const,
  list: (companyId: string) => [...accessoryKeys.lists(), companyId] as const,
  details: () => [...accessoryKeys.all, 'detail'] as const,
  detail: (id: string) => [...accessoryKeys.details(), id] as const,
  byCompany: (companyId: string) => ['accessories', 'byCompany', companyId] as const,
}
